import styled, { css } from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 32px;
  margin: 30px 0 0 0;
`;

export const Form = styled.form`
  ${({ theme }) => css`
    display: grid;
    grid-template-columns: repeat(2, 335px);
    grid-template-rows: repeat(3, 76px);
    gap: 16px;
    text-align: start;

    @media (max-width: ${theme.breakpoints.sm}) {
      grid-template-columns: 1fr;
    }
  `};
`;

export const HelpLink = styled.div`
  ${({ theme }) => css`
    color: ${theme.v2.colors.neutral.lowMedium};
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.xxs};
    font-weight: ${theme.v2.font.weights.regular};
    line-height: ${theme.v2.font.lineHeight.text};
    text-align: center;
    margin: 0;

    a {
      color: ${theme.v2.colors.brand.primaryMedium};
    }
  `};
`;
